import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import type { ModelProductCategory } from '@app/api/Products';
import type { GetColumnType } from '@app/pages/Warehouses/ProductCategories/types';

import type { ColumnsType } from 'antd/es/table';

export const getProductCategoriesColumns: GetColumnType = ({
  onEdit,
  IsProductCategoryEdit,
  productCategories,
}) => {
  const columns: ColumnsType<ModelProductCategory> = [
    {
      title: 'Название',
      dataIndex: 'Name',
      key: 'Name',
      width: 200,
      ellipsis: true,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      title: 'Родительская категория',
      dataIndex: 'ParentCategoryId',
      key: 'ParentCategoryId',
      width: 180,
      ellipsis: true,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {productCategories?.find((category) => category.Id === text)?.Name ||
            '-'}
        </span>
      ),
    },
    {
      title: 'Товары',
      dataIndex: 'productsCount',
      key: 'productsCount',
      render: () => <span>-</span>,
    },
    {
      title: 'Примечание',
      dataIndex: 'Comment',
      key: 'Comment',
      width: 200,
      ellipsis: true,
      render: (text) => (
        <span className="no-wrap-text" style={{ maxWidth: 300 }}>
          {text}
        </span>
      ),
    },
    {
      title: null,
      key: 'actions',
      width: 50,
      render: (row: ModelProductCategory) => (
        <>
          {IsProductCategoryEdit && (
            <Button onClick={() => onEdit(row?.Id)} icon={<EditOutlined />} />
          )}
        </>
      ),
    },
  ];

  return columns;
};
